import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef, useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import NotificationBell from "@/components/NotificationBell";
import PharmacyNotifBell from "@/components/PharmacyNotifBell";
import { ConsultNowAlert } from "@/components/ConsultNowAlert";
import PwaRefreshButton from "@/components/PwaRefreshButton";
import { ShopNotifProvider, useShopNotif } from "@/context/ShopNotifContext";
import { playNewMessageAlert } from "@/hooks/useChatAlerts";
import {
  House,
  PlusCircle,
  ListChecks,
  CalendarCheck,
  CalendarDots,
  Flower,
  ChartBar,
  ChartLineUp,
  Sparkle,
  Package,
  Tag,
  Wallet,
  Bank,
  UsersThree,
  Tray,
  BellRinging,
  List as ListIcon,
  SignOut,
  Gear,
  Stethoscope,
  WhatsappLogo,
  ShieldCheck,
  Robot,
  ChatCircleDots,
  BookOpen,
  MusicNotes,
  Storefront,
  Receipt,
  IdentificationCard,
  UploadSimple,
  X,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Dashboard", icon: House, testid: "nav-dashboard", end: true },
  { to: "/homecare-chat-admin", label: "Chat Homecare", icon: ChatCircleDots, testid: "nav-homecare-chat-admin", adminOnly: true },
  { to: "/homecare-chat-staff", label: "Chat Homecare Saya", icon: ChatCircleDots, testid: "nav-homecare-chat-staff", petugasOnly: true },
  { to: "/konsultasi-admin", label: "Konsultasi Online", icon: ChatCircleDots, testid: "nav-konsultasi-admin", adminOnly: true },
  { to: "/konsultasi-saya", label: "Konsultasi Online Saya", icon: ChatCircleDots, testid: "nav-konsultasi-saya", petugasVisible: true, staffOnly: true },
  { to: "/tambah", label: "Tambah Reservasi", icon: PlusCircle, testid: "nav-tambah" },
  { to: "/reservasi", label: "Semua Reservasi", icon: ListChecks, testid: "nav-reservasi" },
  { to: "/pesanan", label: "Pesanan Multi-Layanan", icon: Package, testid: "nav-pesanan" },
  { to: "/booking-masuk", label: "Booking Masuk", icon: Tray, testid: "nav-booking-masuk" },
  { to: "/pembayaran", label: "Pembayaran", icon: Wallet, testid: "nav-pembayaran" },
  { to: "/calon-batal-otomatis", label: "Calon Batal Otomatis", icon: ListChecks, testid: "nav-calon-batal", superOnly: true },
  { to: "/kasir-shift", label: "Kasir Shift", icon: Wallet, testid: "nav-kasir-shift", billingOnly: true },
  { to: "/wa-log", label: "Log WhatsApp", icon: WhatsappLogo, testid: "nav-wa-log" },
  { to: "/jadwal", label: "Jadwal Hari Ini", icon: CalendarCheck, testid: "nav-jadwal", petugasVisible: true },
  { to: "/kalender", label: "Kalender Jadwal", icon: CalendarDots, testid: "nav-kalender", petugasVisible: true },
  { to: "/pengingat", label: "Pengingat H-1", icon: BellRinging, testid: "nav-pengingat" },
  { to: "/yoga", label: "Prenatal Yoga", icon: Flower, testid: "nav-yoga" },
  { to: "/laporan", label: "Laporan / Rekap", icon: ChartBar, testid: "nav-laporan" },
  { to: "/omzet", label: "Omzet & Kinerja", icon: ChartLineUp, testid: "nav-omzet", superOnly: true, petugasVisible: true },
  { to: "/spa", label: "Laporan Spa", icon: Sparkle, testid: "nav-spa", superOnly: true },
  { to: "/master/layanan", label: "Master Layanan", icon: Package, testid: "nav-master-layanan" },
  { to: "/master/kategori", label: "Kategori Layanan", icon: Tag, testid: "nav-master-kategori" },
  { to: "/master/unit", label: "Poli / Unit", icon: Package, testid: "nav-master-unit" },
  { to: "/master/petugas", label: "Master Petugas", icon: UsersThree, testid: "nav-master-petugas" },
  { to: "/master/sesi-praktik", label: "Sesi Praktik/Antrean", icon: Stethoscope, testid: "nav-sesi-praktik" },
  { to: "/metode-pembayaran", label: "Metode Pembayaran", icon: Bank, testid: "nav-metode-pembayaran", superOnly: true },
  { to: "/pengaturan", label: "Pengaturan", icon: Gear, testid: "nav-pengaturan" },
  { to: "/log-aktivitas", label: "Log Aktivitas", icon: ListChecks, testid: "nav-log-aktivitas", superOnly: true },
  { to: "/diagnostik", label: "Diagnostik Jadwal", icon: Stethoscope, testid: "nav-diagnostik", superOnly: true },
  { to: "/audit-rekonsiliasi", label: "Audit & Rekonsiliasi", icon: ShieldCheck, testid: "nav-audit-rekonsiliasi", superOnly: true },
  { to: "/clinara", label: "CLINARA Receptionist", icon: Robot, testid: "nav-clinara", superOnly: true },
  { to: "/artikel-admin", label: "Artikel & Edukasi", icon: BookOpen, testid: "nav-artikel" },
  { to: "/relaksasi-admin", label: "Relaksasi Digital", icon: MusicNotes, testid: "nav-relaksasi" },
  { to: "/transaksi-digital", label: "Transaksi Digital", icon: Wallet, testid: "nav-transaksi-digital" },
  { to: "/toko-produk", label: "Toko Produk", icon: Storefront, testid: "nav-toko-produk" },
  { to: "/pesanan-toko", label: "Pesanan Toko", icon: Receipt, testid: "nav-pesanan-toko" },
  { to: "/rme-pasien", label: "Rekam Medis", icon: IdentificationCard, testid: "nav-rme-pasien" },
  { to: "/rme-kunjungan", label: "Kunjungan RME", icon: Stethoscope, testid: "nav-rme-kunjungan" },
  { to: "/master/obat", label: "Master Obat", icon: Package, testid: "nav-master-obat" },
  { to: "/stok-mutasi", label: "Stok & Mutasi Obat", icon: ChartBar, testid: "nav-stok-mutasi" },
  { to: "/farmasi", label: "Antrean Farmasi", icon: Stethoscope, testid: "nav-farmasi", pharmacyNav: true },
  { to: "/izin-resep", label: "Izin Resep", icon: ShieldCheck, testid: "nav-izin-resep", superOnly: true },
  { to: "/kesiapan-satusehat", label: "Kesiapan SATUSEHAT", icon: ShieldCheck, testid: "nav-kesiapan-satusehat", superOnly: true },
  { to: "/pemetaan-ihs", label: "Pemetaan IHS", icon: ShieldCheck, testid: "nav-pemetaan-ihs", superOnly: true },
  { to: "/impor-klikmedis", label: "Impor KlikMedis", icon: UploadSimple, testid: "nav-impor-klikmedis", superOnly: true },
];

function NavItems({ onClick, role, counts, hcUnread, billing, pharmacy, pharmPending }) {
  const shopNotif = useShopNotif();
  const visible = NAV.filter((n) => {
    if (n.billingOnly) return !!billing || role === "admin" || role === "super_admin";
    if (n.pharmacyNav) return !!pharmacy || ["farmasi", "admin", "super_admin"].includes(role);
    if (role === "petugas") return n.petugasVisible || n.petugasOnly;
    if (n.petugasOnly) return false;
    if (n.staffOnly) return role !== "admin" && role !== "super_admin";
    if (n.adminOnly) return role === "admin" || role === "super_admin";
    if (n.superOnly) return role === "super_admin";
    return true;
  });
  const badgeFor = (testid) => {
    if (testid === "nav-pesanan-toko") return shopNotif.unread || 0;
    if (testid === "nav-farmasi") return pharmPending || 0;
    if (testid === "nav-homecare-chat-admin" || testid === "nav-homecare-chat-staff") return hcUnread || 0;
    if (!counts) return 0;
    if (testid === "nav-booking-masuk") return counts.booking_masuk || 0;
    if (testid === "nav-pembayaran") return counts.payment_pending || 0;
    return 0;
  };
  return (
    <nav className="flex flex-col gap-1">
      {visible.map(({ to, label, icon: Icon, testid, end }) => {
        const badge = badgeFor(testid);
        return (
        <NavLink
          key={to}
          to={to}
          end={end}
          onClick={onClick}
          data-testid={testid}
          className={({ isActive }) =>
            `group flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
              isActive
                ? "bg-[#EEE6FF] text-[#6A38C7]"
                : "text-slate-500 hover:bg-rose-50 hover:text-[#6A38C7]"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={22} weight={isActive ? "duotone" : "regular"} />
              <span className="flex-1">{label}</span>
              {badge > 0 && (
                <span data-testid={`${testid}-badge`} className="ml-auto inline-flex min-w-[20px] items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-[10px] font-bold text-white">{badge}</span>
              )}
            </>
          )}
        </NavLink>
        );
      })}
    </nav>
  );
}

function Brand() {
  return (
    <div className="flex items-center gap-3 px-2">
      <img src={`${process.env.PUBLIC_URL}/logo.webp`} alt="GBS Clinic & Birth Center" className="h-12 w-auto object-contain" />
    </div>
  );
}

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState(null);
  const [hcSummary, setHcSummary] = useState({ total: 0, items: [] });
  const navigate = useNavigate();
  const hcKnown = useRef(null);

  useEffect(() => {
    if (!user || user.role === "petugas") return;
    const fetchCounts = () => api.get("/inbox-counts").then((r) => setCounts(r.data)).catch(() => {});
    fetchCounts();
    const t = setInterval(fetchCounts, 30000);
    return () => clearInterval(t);
  }, [user]);

  // Single, centralized poll of the shared unread summary (badge + bell items + the ONE
  // room-chat sound source). NotificationBell is display-only; the chat pages run their
  // own sound while a room is open. This prevents Layout+Bell from double-sounding.
  useEffect(() => {
    if (!user) return;
    const isAdminRole = user.role === "admin" || user.role === "super_admin";
    const fetchHc = () => {
      if (document.hidden) return;
      api.get("/homecare/rooms/unread-summary").then((r) => {
        const data = r.data || { total: 0, items: [] };
        setHcSummary({ total: data.total || 0, items: data.items || [] });
        // Fresh-event detection per room (unread increased) -> ONE chat sound (admin only),
        // gated by ChatSoundBanner preference; no replay on reload (init known map first).
        if (isAdminRole) {
          const cur = {};
          (data.items || []).forEach((it) => { cur[it.room_id] = it.unread || 0; });
          if (hcKnown.current === null) { hcKnown.current = cur; return; }
          let bumped = false;
          for (const rid of Object.keys(cur)) {
            if ((cur[rid] || 0) > (hcKnown.current[rid] || 0)) bumped = true;
          }
          hcKnown.current = cur;
          if (bumped) {
            let pref = "on";
            try { pref = localStorage.getItem("gbs_chat_sound_enabled"); } catch (e) {}
            if (pref !== "dismissed") playNewMessageAlert();
          }
        }
      }).catch(() => {});
    };
    fetchHc();
    const t = setInterval(fetchHc, 10000);
    return () => clearInterval(t);
  }, [user]);

  const [pharm, setPharm] = useState({ enabled: false, pending: 0, items: [] });
  const pharmLast = useRef(null);
  const fetchPharm = useCallback(() => {
    api.get("/pharmacy/notifications").then((r) => {
      const d = r.data || { enabled: false, pending: 0, items: [] };
      setPharm(d);
      const sig = `${d.pending}|${(d.items[0] || {}).id || ""}|${(d.items[0] || {}).created_at || ""}`;
      if (pharmLast.current !== null && pharmLast.current !== sig) window.dispatchEvent(new Event("gbs-pharmacy-update"));
      pharmLast.current = sig;
    }).catch(() => {});
  }, []);
  const canPharm = !!user && (user.role === "farmasi" || user.can_pharmacy === true);
  useEffect(() => {
    if (!canPharm) return;
    fetchPharm();
    const t = setInterval(fetchPharm, 10000);
    return () => clearInterval(t);
  }, [canPharm, fetchPharm]);

  const hcUnread = hcSummary.total || 0;
  const isAdmin = user && (user.role === "admin" || user.role === "super_admin");
  return (
    <ShopNotifProvider enabled={isAdmin}>
    <div className="min-h-screen bg-[#FAF7FF]">
      {/* Desktop sidebar */}
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-72 flex-col border-r border-rose-100/70 bg-white p-5 lg:flex">
        <div className="mb-8 mt-2 flex items-center justify-between gap-2">
          <Brand />
          <div className="flex items-center">
            {pharm.enabled && <PharmacyNotifBell items={pharm.items} onRead={fetchPharm} testid="pharm-notif-bell" alignLeft />}
            {user && user.role !== "petugas" && <NotificationBell hcItems={hcSummary.items} hcTotal={hcUnread} />}
          </div>
        </div>
        <div className="flex-1 overflow-y-auto pr-1">
          <NavItems role={user?.role} counts={counts} hcUnread={hcUnread} billing={!!user?.can_manage_billing} pharmacy={!!user?.can_pharmacy} pharmPending={pharm.enabled ? pharm.pending : 0} />
        </div>
        <div className="mt-4 shrink-0 border-t border-rose-100 pt-4">
          <p className="px-2 text-xs text-slate-400">Masuk sebagai</p>
          <p className="truncate px-2 text-sm font-semibold text-slate-700">{user?.name}</p>
          <PwaRefreshButton testid="pwa-refresh-sidebar" className="mt-2 flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-[#6A38C7] transition-colors hover:bg-[#EEE6FF]" />
          <button
            data-testid="logout-button"
            onClick={logout}
            className="mt-1 flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-rose-500 transition-colors hover:bg-rose-50"
          >
            <SignOut size={20} weight="duotone" /> Keluar
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <header className="sticky top-0 z-20 flex items-center justify-between border-b border-rose-100/70 bg-white/90 px-4 py-3 backdrop-blur lg:hidden">
        <Brand />
        <div className="flex items-center gap-1">
          {pharm.enabled && <PharmacyNotifBell items={pharm.items} onRead={fetchPharm} testid="pharm-notif-bell-mobile" />}
          {user && user.role !== "petugas" && <NotificationBell hcItems={hcSummary.items} hcTotal={hcUnread} />}
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(true)}
            className="rounded-xl p-2 text-slate-600 hover:bg-rose-50"
          >
            <ListIcon size={26} weight="bold" />
          </button>
        </div>
      </header>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-slate-900/30" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 flex h-full w-72 flex-col bg-white p-5 shadow-xl animate-fade-up">
            <div className="mb-6 flex items-center justify-between">
              <Brand />
              <button onClick={() => setOpen(false)} className="rounded-lg p-1 text-slate-500">
                <X size={22} />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto pr-1">
              <NavItems onClick={() => setOpen(false)} role={user?.role} counts={counts} hcUnread={hcUnread} billing={!!user?.can_manage_billing} pharmacy={!!user?.can_pharmacy} pharmPending={pharm.enabled ? pharm.pending : 0} />
            </div>
            <PwaRefreshButton testid="pwa-refresh-sidebar-mobile" className="mt-3 flex w-full shrink-0 items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-[#6A38C7] hover:bg-[#EEE6FF]" />
            <button
              data-testid="logout-button-mobile"
              onClick={logout}
              className="mt-1 flex w-full shrink-0 items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-rose-500 hover:bg-rose-50"
            >
              <SignOut size={20} weight="duotone" /> Keluar
            </button>
          </div>
        </div>
      )}

      <main className="lg:pl-72">
        <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">{children}</div>
      </main>
      {user?.has_staff && <ConsultNowAlert />}

      {/* Floating add button on mobile */}
      <button
        data-testid="fab-add"
        onClick={() => navigate("/tambah")}
        className="fixed bottom-6 right-5 z-20 flex h-14 w-14 items-center justify-center rounded-full bg-[#7C4DE0] text-white shadow-lg transition-transform active:scale-90 lg:hidden"
      >
        <PlusCircle size={30} weight="fill" />
      </button>
    </div>
    </ShopNotifProvider>
  );
}
